import React from "react";
import "./FAQ_Accordian.css";
import { Accordion } from "react-bootstrap";

function FAQ_Accordian() {
  return (
    <>
      <section className="FAQ_Accordian">
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              1) How can I pay my electricity bill through the platform?
            </Accordion.Header>
            <Accordion.Body>
              Simply log in to your account, select the electricity bill payment
              option, enter the required details, and complete the payment using
              your preferred payment method. Payments are processed securely and
              reflected in your account history.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              2) Can I upload my electricity bill and meter readings?
            </Accordion.Header>
            <Accordion.Body>
              Yes. You can upload a photo or PDF of your electricity bill and
              enter your current meter readings directly through the platform.
              This helps maintain accurate records and simplifies bill
              management.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              3) Where can I view my payment history and receipts?
            </Accordion.Header>
            <Accordion.Body>
              All completed transactions are stored in your payment history
              section. You can view receipts whenever
              needed for your personal records or verification purposes.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              4) Are my payments and personal details secure?
            </Accordion.Header>
            <Accordion.Body>
              Absolutely. We use secure payment gateways and industry-standard
              encryption to protect your personal information and transaction
              data, ensuring every payment is safe and reliable.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              5) How do smart rent reminders work?
            </Accordion.Header>
            <Accordion.Body>
              Smart rent reminders automatically notify you before your rent due
              date. You can receive alerts through email, SMS, or app
              notifications to help avoid missed payments and late fees.
            </Accordion.Body>
          </Accordion.Item>

        
        </Accordion>
      </section>
    </>
  );
}

export default FAQ_Accordian;
